export const LOGIN_STRUCTURE = {
  logo: 'assets/img/logo-company.jpg',
  img: 'assets/img/background-personae.png',
  title: 'Recursos + humanos',
  subtitle: 'Panel de Administración',
  registration: false
};

